var map = {
	"./de.json": 385,
	"./en.json": 386,
	"./es.json": 387,
	"./fr.json": 388,
	"./it.json": 389,
	"./skins/class.it.json": 668,
	"./skins/default.en.json": 669,
	"./skins/education.de.json": 670,
	"./skins/education.en.json": 671,
	"./skins/education.es.json": 672,
	"./skins/education.fr.json": 673,
	"./skins/education.it.json": 674,
	"./skins/museum.de.json": 675,
	"./skins/museum.en.json": 676,
	"./skins/museum.es.json": 677,
	"./skins/museum.fr.json": 678,
	"./skins/museum.it.json": 679,
	"./tenants/ancot.it.json": 680,
	"./tenants/class.it.json": 681,
	"./tenants/csp.en.json": 682,
	"./tenants/csp.it.json": 683,
	"./tenants/ekom.it.json": 684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;